import { FeatureToggleValues } from './model/feature-toggles.model';

export interface GenesysCloudFeatureTogglesState {
  featureToggles: FeatureToggleValues,
  featureTogglesLoaded: boolean
}

export const initialState = (): GenesysCloudFeatureTogglesState => ({
  featureToggles: {},
  featureTogglesLoaded: false
});
